import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
export default class BirthdayBanner extends Component {
  view() {
    const players = this.attrs.players || [];
    if (players.length === 0) return null;
    return m("div", {
      className: "BirthdayBanner-wrapper"
    }, players.map(player => m("div", {
      className: "BirthdayBanner",
      key: player.id
    }, m("div", {
      className: "BirthdayBanner-decorations"
    }, m("span", {
      className: "BirthdayBanner-star star-1"
    }, "\u2728"), m("span", {
      className: "BirthdayBanner-star star-2"
    }, "\uD83E\uDD81"), m("span", {
      className: "BirthdayBanner-star star-3"
    }, "\uD83C\uDF89")), m("div", {
      className: "BirthdayBanner-player"
    }, m("div", {
      className: "BirthdayBanner-avatar-wrapper"
    }, player.photoUrl ? m("img", {
      src: player.photoUrl,
      alt: player.name,
      className: "BirthdayBanner-avatar"
    }) : m("div", {
      className: "BirthdayBanner-avatar BirthdayBanner-avatar--placeholder"
    }, m("i", {
      className: "fas fa-user"
    })), player.number && m("span", {
      className: "BirthdayBanner-number"
    }, "#", player.number)), m("div", {
      className: "BirthdayBanner-info"
    }, m("div", {
      className: "BirthdayBanner-badge"
    }, m("span", null, "\uD83C\uDF82 ", app.translator.trans('bizkaitarra-lineup.forum.birthdays.hero_age', {
      age: player.age
    }))), m("h3", {
      className: "BirthdayBanner-title"
    }, app.translator.trans('bizkaitarra-lineup.forum.birthdays.banner_title', {
      name: player.name
    })), m("h3", {
      className: "BirthdayBanner-title-mobile"
    }, player.name), m("p", {
      className: "BirthdayBanner-subtitle"
    }, app.translator.trans('bizkaitarra-lineup.forum.birthdays.banner_subtitle', {
      name: player.name,
      age: player.age
    })))), m("div", {
      className: "BirthdayBanner-actions"
    }, player.wishesCount > 0 && m("span", {
      className: "BirthdayBanner-counter"
    }, "\u2764\uFE0F ", app.translator.trans('bizkaitarra-lineup.forum.birthdays.wishes_count', {
      count: player.wishesCount
    })), m(Link, {
      href: "/urtebetetzea/".concat(player.slug),
      className: "Button Button--primary BirthdayBanner-btn"
    }, m("span", {
      className: "BirthdayBanner-btn-icon"
    }, "\uD83E\uDD81"), app.translator.trans('bizkaitarra-lineup.forum.birthdays.congratulate_btn'))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/BirthdayBanner', BirthdayBanner);